import {clsx} from 'clsx'

import {useLabelId} from '../LabelIdContext'
import styles from './Items.module.css'

export const Items = ({children, className}: {children: React.ReactNode; className?: string}) => {
  const labelId = useLabelId()

  return (
    <ul aria-labelledby={labelId} className={clsx(styles.list, className)}>
      {children}
    </ul>
  )
}
